const PUBLIC_PAGES = ['/', '/reset-password', '/zendesk/login']

export default PUBLIC_PAGES
